/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _even = __webpack_require__(1);

__webpack_require__(2);

$(document).ready(function () {
  _even.Even.backToTop();
  _even.Even.mobileNavbar();
  _even.Even.toc();
  _even.Even.fancybox();
});

hljs.initHighlighting();
_even.Even.highlight();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Even = {};

Even.backToTop = function () {
  var $backToTop = $('#back-to-top');

  $(window).scroll(function () {
    if ($(window).scrollTop() > 100) {
      $backToTop.fadeIn(1000);
    } else {
      $backToTop.fadeOut(1000);
    }
  });

  $backToTop.click(function () {
    $('body,html').animate({ scrollTop: 0 });
  });
};

Even.mobileNavbar = function () {
  var $mobileNav = $('#mobile-navbar');
  var $mobileNavIcon = $('.mobile-navbar-icon');
  var slideout = new Slideout({
    'panel': document.getElementById('mobile-panel'),
    'menu': document.getElementById('mobile-menu'),
    'padding': 180,
    'tolerance': 70
  });
  slideout.disableTouch();

  $mobileNavIcon.click(function () {
    slideout.toggle();
  });

  slideout.on('beforeopen', function () {
    $mobileNav.addClass('fixed-open');
    $mobileNavIcon.addClass('icon-click').removeClass('icon-out');
  });

  slideout.on('beforeclose', function () {
    $mobileNav.removeClass('fixed-open');
    $mobileNavIcon.addClass('icon-out').removeClass('icon-click');
  });

  $('#mobile-panel').on('touchend', function () {
    slideout.isOpen() && $mobileNavIcon.click();
  });
};

Even._initToc = function () {
  var SPACING = 20;
  var $toc = $('.post-toc');
  var $footer = $('.post-footer');

  if ($toc.length) {
    var minScrollTop = $toc.offset().top - SPACING;
    var maxScrollTop = $footer.offset().top - $toc.height() - SPACING;

    var tocState = {
      start: {
        'position': 'absolute',
        'top': minScrollTop
      },
      process: {
        'position': 'fixed',
        'top': SPACING
      },
      end: {
        'position': 'absolute',
        'top': maxScrollTop
      }
    };

    $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();

      if (scrollTop < minScrollTop) {
        $toc.css(tocState.start);
      } else if (scrollTop > maxScrollTop) {
        $toc.css(tocState.end);
      } else {
        $toc.css(tocState.process);
      }
    });
  }

  var HEADERFIX = 30;
  var $toclink = $('.toc-link');
  var $headerlink = $('.headerlink');

  var headerlinkTop = $.map($headerlink, function (link) {
    return $(link).offset().top;
  });

  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();

    for (var i = 0; i < $toclink.length; i++) {
      var isLastOne = i + 1 === $toclink.length;
      var currentTop = headerlinkTop[i] - HEADERFIX;
      var nextTop = isLastOne ? Infinity : headerlinkTop[i + 1] - HEADERFIX;

      if (currentTop < scrollTop && scrollTop <= nextTop) {
        $($toclink[i]).addClass('active');
      } else {
        $($toclink[i]).removeClass('active');
      }
    }
  });
};

Even.fancybox = function () {
  if ($.fancybox) {
    $('.post-content').each(function () {
      $(this).find('img').each(function () {
        $(this).wrap('<a class="fancybox" href="' + this.src + '" data-fancybox="gallery" data-caption="' + this.title + '"></a>');
      });
    });

    $('.fancybox').fancybox({
      selector: '.fancybox',
      protect: true
    });
  }
};

Even.highlight = function () {
  var blocks = document.querySelectorAll('pre code');
  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];
    var rootElement = block.parentElement;
    var lineCodes = block.innerHTML.split(/\n/).slice(0, -1);
    var lineLength = lineCodes.length;

    var codeLineHtml = '';
    for (var _i = 0; _i < lineLength; _i++) {
      codeLineHtml += '<div class="line">' + (_i + 1) + '</div>';
    }

    var codeHtml = '';
    for (var _i2 = 0; _i2 < lineLength; _i2++) {
      codeHtml += '<div class="line">' + lineCodes[_i2] + '</div>';
    }

    block.className += ' highlight';
    var figure = document.createElement('figure');
    figure.className = block.className;
    figure.innerHTML = '<table><tbody><tr><td class="gutter"><pre>' + codeLineHtml + '</pre></td><td class="code"><pre>' + codeHtml + '</pre></td></tr></tbody></table>';

    rootElement.parentElement.replaceChild(figure, rootElement);
  }
};

Even.toc = function () {
  var tocContainer = document.getElementById('post-toc');
  if (tocContainer !== null) {
    var toc = document.getElementById('TableOfContents');
    if (toc === null) {
      // toc = true, but there are no headings
      tocContainer.parentNode.removeChild(tocContainer);
    } else {
      this._linkToc();
      this._initToc();
    }
  }
};

Even._linkToc = function () {
  var links = document.querySelectorAll('#TableOfContents a');
  for (var i = 0; i < links.length; i++) {
    links[i].className += ' toc-link';
  }for (var num = 1; num <= 6; num++) {
    var headers = document.querySelectorAll('.post-content>h' + num);
    for (var _i3 = 0; _i3 < headers.length; _i3++) {
      var header = headers[_i3];
      header.innerHTML = '<a href="#' + header.id + '" class="headerlink" title="' + header.innerHTML + '"></a>' + header.innerHTML;
    }
  }
};

exports.Even = Even;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// even.min.js